import { Loader2 } from "lucide-react";

const LoaderWithOverlay = () => {
	return (
		<div className="absolute inset-0 flex items-center justify-center bg-background/75 z-10">
			<span className="text-foreground text-lg mr-2.5">Loading...</span>
			<Loader2 className="h-8 w-8 animate-spin text-foreground" />
		</div>
	);
};

export default LoaderWithOverlay;
